import React, { useEffect } from "react";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
const SuspiciousCriteria = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div className="section-top">
            <div className="container">
                <Breadcrumb pathFrom={"/"} textFrom={"Trang chủ"} to={"Bộ tiêu chí nhận diện dấu hiệu đáng ngờ"} />
                <div className="mx-3 mx-md-5">
                    <h2 className="fs-3 fw-bold my-4 text-center text-uppercase">BỘ TIÊU CHÍ NHẬN DIỆN DẤU HIỆU ĐÁNG NGỜ</h2>
                    <div className="mb-5">
                        <>
                            <h2
                                style={{
                                    margin: "8pt 0cm 6pt",
                                    textAlign: "center",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                                align="center"
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    BỘ TIÊU CHÍ DẤU HIỆU ĐÁNG NGỜ CƠ BẢN THEO ĐIỀU 27 LUẬT PCRT
                                </span>
                            </h2>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Bộ tiêu chí CB01–CB12 cụ thể hóa đầy đủ 8 khoản Điều 27 và áp dụng đồng
                                    thời với TG01–TG27 theo Điều 29, trên các dịch vụ Công ty được phép cung
                                    ứng. Tiêu chí cơ bản được rà soát khi tiếp nhận khách hàng, cập nhật hồ
                                    sơ, nhận yêu cầu giao dịch, giám sát quan hệ và xử lý thông tin từ đối
                                    tác. Không cần phát sinh thêm dấu hiệu chuyên biệt TG để mở hồ sơ CB.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Mỗi tiêu chí tạo cảnh báo cần phân tích theo Điều 26 Luật PCRT. Điểm số,
                                    số lần liên hệ, tỷ lệ doanh số hoặc thời gian nội bộ chỉ hỗ trợ ưu tiên,
                                    không thay cơ sở nghi ngờ và không làm dừng thời hạn luật định. Những tín
                                    hiệu về lời nói, ủy quyền và thông tin bên ngoài phải có tuyến tiếp nhận
                                    thủ công khi chưa tự động hóa.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "8pt 0cm 6pt",
                                    textAlign: "center",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                                align="center"
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    BẢNG ĐỐI CHIẾU 8 KHOẢN ĐIỀU 27
                                </span>
                            </h3>
                            <table
                                className="MsoNormalTable"
                                style={{ borderCollapse: "collapse", width: "101.38%" }}
                                border={0}
                                cellSpacing={0}
                                cellPadding={0}
                            >
                                <thead>
                                    <tr style={{ pageBreakInside: "avoid" }}>
                                        <td
                                            style={{
                                                width: "16.2405%",
                                                border: "1pt solid rgb(217, 217, 217)",
                                                background: "#e7e6e6",
                                                padding: "0cm 5.4pt"
                                            }}
                                        >
                                            <p
                                                style={{
                                                    margin: "0cm 0cm 4pt",
                                                    lineHeight: "110%",
                                                    textAlign: "justify",
                                                    fontSize: "12pt",
                                                    fontFamily: '"Times New Roman", serif',
                                                    color: "black"
                                                }}
                                            >
                                                <span style={{ fontSize: "13pt" }}>
                                                    <strong>
                                                        <span style={{ lineHeight: "110%" }}>Khoản Điều 27</span>
                                                    </strong>
                                                </span>
                                            </p>
                                        </td>
                                        <td
                                            style={{
                                                width: "50.8651%",
                                                borderWidth: "1pt 1pt 1pt medium",
                                                borderStyle: "solid solid solid none",
                                                borderColor:
                                                    "rgb(217, 217, 217) rgb(217, 217, 217) rgb(217, 217, 217) currentcolor",
                                                background: "#e7e6e6",
                                                padding: "0cm 5.4pt"
                                            }}
                                        >
                                            <p
                                                style={{
                                                    margin: "0cm 0cm 4pt",
                                                    lineHeight: "110%",
                                                    textAlign: "justify",
                                                    fontSize: "12pt",
                                                    fontFamily: '"Times New Roman", serif',
                                                    color: "black"
                                                }}
                                            >
                                                <span style={{ fontSize: "13pt" }}>
                                                    <strong>
                                                        <span style={{ lineHeight: "110%" }}>Nhóm nhận diện</span>
                                                    </strong>
                                                </span>
                                            </p>
                                        </td>
                                        <td
                                            style={{
                                                width: "32.8944%",
                                                borderWidth: "1pt 1pt 1pt medium",
                                                borderStyle: "solid solid solid none",
                                                borderColor:
                                                    "rgb(217, 217, 217) rgb(217, 217, 217) rgb(217, 217, 217) currentcolor",
                                                background: "#e7e6e6",
                                                padding: "0cm 5.4pt"
                                            }}
                                        >
                                            <p
                                                style={{
                                                    margin: "0cm 0cm 4pt",
                                                    lineHeight: "110%",
                                                    textAlign: "justify",
                                                    fontSize: "12pt",
                                                    fontFamily: '"Times New Roman", serif',
                                                    color: "black"
                                                }}
                                            >
                                                <span style={{ fontSize: "13pt" }}>
                                                    <strong>
                                                        <span style={{ lineHeight: "110%" }}>Mã tiêu chí</span>
                                                    </strong>
                                                </span>
                                            </p>
                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr style={{ pageBreakInside: "avoid" }}>
                                        <td
                                            style={{
                                                width: "16.2405%",
                                                borderWidth: "medium 1pt 1pt",
                                                borderStyle: "none solid solid",
                                                borderColor: "currentcolor rgb(217, 217, 217) rgb(217, 217, 217)",
                                                padding: "0cm 5.4pt"
                                            }}
                                        >
                                            <p
                                                style={{
                                                    margin: "0cm 0cm 4pt",
                                                    lineHeight: "110%",
                                                    textAlign: "justify",
                                                    fontSize: "12pt",
                                                    fontFamily: '"Times New Roman", serif',
                                                    color: "black"
                                                }}
                                            >
                                                <span style={{ lineHeight: "110%", fontSize: "13pt" }}>1</span>
                                            </p>
                                        </td>
                                        <td
                                            style={{
                                                width: "50.8651%",
                                                borderWidth: "medium 1pt 1pt medium",
                                                borderStyle: "none solid solid none",
                                                borderColor:
                                                    "currentcolor rgb(217, 217, 217) rgb(217, 217, 217) currentcolor",
                                                padding: "0cm 5.4pt"
                                            }}
                                        >
                                            <p
                                                style={{
                                                    margin: "0cm 0cm 4pt",
                                                    lineHeight: "110%",
                                                    textAlign: "justify",
                                                    fontSize: "12pt",
                                                    fontFamily: '"Times New Roman", serif',
                                                    color: "black"
                                                }}
                                            >
                                                <span style={{ lineHeight: "110%", fontSize: "13pt" }}>
                                                    Từ chối hoặc thông tin KYC sai thiếu mâu thuẫn
                                                </span>
                                            </p>
                                        </td>
                                        <td
                                            style={{
                                                width: "32.8944%",
                                                borderWidth: "medium 1pt 1pt medium",
                                                borderStyle: "none solid solid none",
                                                borderColor:
                                                    "currentcolor rgb(217, 217, 217) rgb(217, 217, 217) currentcolor",
                                                padding: "0cm 5.4pt"
                                            }}
                                        >
                                            <p
                                                style={{
                                                    margin: "0cm 0cm 4pt",
                                                    lineHeight: "110%",
                                                    textAlign: "justify",
                                                    fontSize: "12pt",
                                                    fontFamily: '"Times New Roman", serif',
                                                    color: "black"
                                                }}
                                            >
                                                <span style={{ lineHeight: "110%", fontSize: "13pt" }}>
                                                    CB01, CB02
                                                </span>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr style={{ pageBreakInside: "avoid" }}>
                                        <td
                                            style={{
                                                width: "16.2405%",
                                                borderWidth: "medium 1pt 1pt",
                                                borderStyle: "none solid solid",
                                                borderColor: "currentcolor rgb(217, 217, 217) rgb(217, 217, 217)",
                                                padding: "0cm 5.4pt"
                                            }}
                                        >
                                            <p
                                                style={{
                                                    margin: "0cm 0cm 4pt",
                                                    lineHeight: "110%",
                                                    textAlign: "justify",
                                                    fontSize: "12pt",
                                                    fontFamily: '"Times New Roman", serif',
                                                    color: "black"
                                                }}
                                            >
                                                <span style={{ lineHeight: "110%", fontSize: "13pt" }}>2</span>
                                            </p>
                                        </td>
                                        <td
                                            style={{
                                                width: "50.8651%",
                                                borderWidth: "medium 1pt 1pt medium",
                                                borderStyle: "none solid solid none",
                                                borderColor:
                                                    "currentcolor rgb(217, 217, 217) rgb(217, 217, 217) currentcolor",
                                                padding: "0cm 5.4pt"
                                            }}
                                        >
                                            <p
                                                style={{
                                                    margin: "0cm 0cm 4pt",
                                                    lineHeight: "110%",
                                                    textAlign: "justify",
                                                    fontSize: "12pt",
                                                    fontFamily: '"Times New Roman", serif',
                                                    color: "black"
                                                }}
                                            >
                                                <span style={{ lineHeight: "110%", fontSize: "13pt" }}>
                                                    Thuyết phục không báo cáo
                                                </span>
                                            </p>
                                        </td>
                                        <td
                                            style={{
                                                width: "32.8944%",
                                                borderWidth: "medium 1pt 1pt medium",
                                                borderStyle: "none solid solid none",
                                                borderColor:
                                                    "currentcolor rgb(217, 217, 217) rgb(217, 217, 217) currentcolor",
                                                padding: "0cm 5.4pt"
                                            }}
                                        >
                                            <p
                                                style={{
                                                    margin: "0cm 0cm 4pt",
                                                    lineHeight: "110%",
                                                    textAlign: "justify",
                                                    fontSize: "12pt",
                                                    fontFamily: '"Times New Roman", serif',
                                                    color: "black"
                                                }}
                                            >
                                                <span style={{ lineHeight: "110%", fontSize: "13pt" }}>CB03</span>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr style={{ pageBreakInside: "avoid" }}>
                                        <td
                                            style={{
                                                width: "16.2405%",
                                                borderWidth: "medium 1pt 1pt",
                                                borderStyle: "none solid solid",
                                                borderColor: "currentcolor rgb(217, 217, 217) rgb(217, 217, 217)",
                                                padding: "0cm 5.4pt"
                                            }}
                                        >
                                            <p
                                                style={{
                                                    margin: "0cm 0cm 4pt",
                                                    lineHeight: "110%",
                                                    textAlign: "justify",
                                                    fontSize: "12pt",
                                                    fontFamily: '"Times New Roman", serif',
                                                    color: "black"
                                                }}
                                            >
                                                <span style={{ lineHeight: "110%", fontSize: "13pt" }}>3</span>
                                            </p>
                                        </td>
                                        <td
                                            style={{
                                                width: "50.8651%",
                                                borderWidth: "medium 1pt 1pt medium",
                                                borderStyle: "none solid solid none",
                                                borderColor:
                                                    "currentcolor rgb(217, 217, 217) rgb(217, 217, 217) currentcolor",
                                                padding: "0cm 5.4pt"
                                            }}
                                        >
                                            <p
                                                style={{
                                                    margin: "0cm 0cm 4pt",
                                                    lineHeight: "110%",
                                                    textAlign: "justify",
                                                    fontSize: "12pt",
                                                    fontFamily: '"Times New Roman", serif',
                                                    color: "black"
                                                }}
                                            >
                                                <span style={{ lineHeight: "110%", fontSize: "13pt" }}>
                                                    Không xác định khách hàng hoặc bên liên quan
                                                </span>
                                            </p>
                                        </td>
                                        <td
                                            style={{
                                                width: "32.8944%",
                                                borderWidth: "medium 1pt 1pt medium",
                                                borderStyle: "none solid solid none",
                                                borderColor:
                                                    "currentcolor rgb(217, 217, 217) rgb(217, 217, 217) currentcolor",
                                                padding: "0cm 5.4pt"
                                            }}
                                        >
                                            <p
                                                style={{
                                                    margin: "0cm 0cm 4pt",
                                                    lineHeight: "110%",
                                                    textAlign: "justify",
                                                    fontSize: "12pt",
                                                    fontFamily: '"Times New Roman", serif',
                                                    color: "black"
                                                }}
                                            >
                                                <span style={{ lineHeight: "110%", fontSize: "13pt" }}>
                                                    CB04, CB05
                                                </span>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr style={{ pageBreakInside: "avoid" }}>
                                        <td
                                            style={{
                                                width: "16.2405%",
                                                borderWidth: "medium 1pt 1pt",
                                                borderStyle: "none solid solid",
                                                borderColor: "currentcolor rgb(217, 217, 217) rgb(217, 217, 217)",
                                                padding: "0cm 5.4pt"
                                            }}
                                        >
                                            <p
                                                style={{
                                                    margin: "0cm 0cm 4pt",
                                                    lineHeight: "110%",
                                                    textAlign: "justify",
                                                    fontSize: "12pt",
                                                    fontFamily: '"Times New Roman", serif',
                                                    color: "black"
                                                }}
                                            >
                                                <span style={{ lineHeight: "110%", fontSize: "13pt" }}>4</span>
                                            </p>
                                        </td>
                                        <td
                                            style={{
                                                width: "50.8651%",
                                                borderWidth: "medium 1pt 1pt medium",
                                                borderStyle: "none solid solid none",
                                                borderColor:
                                                    "currentcolor rgb(217, 217, 217) rgb(217, 217, 217) currentcolor",
                                                padding: "0cm 5.4pt"
                                            }}
                                        >
                                            <p
                                                style={{
                                                    margin: "0cm 0cm 4pt",
                                                    lineHeight: "110%",
                                                    textAlign: "justify",
                                                    fontSize: "12pt",
                                                    fontFamily: '"Times New Roman", serif',
                                                    color: "black"
                                                }}
                                            >
                                                <span style={{ lineHeight: "110%", fontSize: "13pt" }}>
                                                    Số điện thoại không liên lạc hoặc không tồn tại
                                                </span>
                                            </p>
                                        </td>
                                        <td
                                            style={{
                                                width: "32.8944%",
                                                borderWidth: "medium 1pt 1pt medium",
                                                borderStyle: "none solid solid none",
                                                borderColor:
                                                    "currentcolor rgb(217, 217, 217) rgb(217, 217, 217) currentcolor",
                                                padding: "0cm 5.4pt"
                                            }}
                                        >
                                            <p
                                                style={{
                                                    margin: "0cm 0cm 4pt",
                                                    lineHeight: "110%",
                                                    textAlign: "justify",
                                                    fontSize: "12pt",
                                                    fontFamily: '"Times New Roman", serif',
                                                    color: "black"
                                                }}
                                            >
                                                <span style={{ lineHeight: "110%", fontSize: "13pt" }}>CB06</span>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr style={{ pageBreakInside: "avoid" }}>
                                        <td
                                            style={{
                                                width: "16.2405%",
                                                borderWidth: "medium 1pt 1pt",
                                                borderStyle: "none solid solid",
                                                borderColor: "currentcolor rgb(217, 217, 217) rgb(217, 217, 217)",
                                                padding: "0cm 5.4pt"
                                            }}
                                        >
                                            <p
                                                style={{
                                                    margin: "0cm 0cm 4pt",
                                                    lineHeight: "110%",
                                                    textAlign: "justify",
                                                    fontSize: "12pt",
                                                    fontFamily: '"Times New Roman", serif',
                                                    color: "black"
                                                }}
                                            >
                                                <span style={{ lineHeight: "110%", fontSize: "13pt" }}>5</span>
                                            </p>
                                        </td>
                                        <td
                                            style={{
                                                width: "50.8651%",
                                                borderWidth: "medium 1pt 1pt medium",
                                                borderStyle: "none solid solid none",
                                                borderColor:
                                                    "currentcolor rgb(217, 217, 217) rgb(217, 217, 217) currentcolor",
                                                padding: "0cm 5.4pt"
                                            }}
                                        >
                                            <p
                                                style={{
                                                    margin: "0cm 0cm 4pt",
                                                    lineHeight: "110%",
                                                    textAlign: "justify",
                                                    fontSize: "12pt",
                                                    fontFamily: '"Times New Roman", serif',
                                                    color: "black"
                                                }}
                                            >
                                                <span style={{ lineHeight: "110%", fontSize: "13pt" }}>
                                                    Lệnh hoặc ủy quyền của chủ thể trong Danh sách cảnh báo
                                                </span>
                                            </p>
                                        </td>
                                        <td
                                            style={{
                                                width: "32.8944%",
                                                borderWidth: "medium 1pt 1pt medium",
                                                borderStyle: "none solid solid none",
                                                borderColor:
                                                    "currentcolor rgb(217, 217, 217) rgb(217, 217, 217) currentcolor",
                                                padding: "0cm 5.4pt"
                                            }}
                                        >
                                            <p
                                                style={{
                                                    margin: "0cm 0cm 4pt",
                                                    lineHeight: "110%",
                                                    textAlign: "justify",
                                                    fontSize: "12pt",
                                                    fontFamily: '"Times New Roman", serif',
                                                    color: "black"
                                                }}
                                            >
                                                <span style={{ lineHeight: "110%", fontSize: "13pt" }}>CB07</span>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr style={{ pageBreakInside: "avoid" }}>
                                        <td
                                            style={{
                                                width: "16.2405%",
                                                borderWidth: "medium 1pt 1pt",
                                                borderStyle: "none solid solid",
                                                borderColor: "currentcolor rgb(217, 217, 217) rgb(217, 217, 217)",
                                                padding: "0cm 5.4pt"
                                            }}
                                        >
                                            <p
                                                style={{
                                                    margin: "0cm 0cm 4pt",
                                                    lineHeight: "110%",
                                                    textAlign: "justify",
                                                    fontSize: "12pt",
                                                    fontFamily: '"Times New Roman", serif',
                                                    color: "black"
                                                }}
                                            >
                                                <span style={{ lineHeight: "110%", fontSize: "13pt" }}>6</span>
                                            </p>
                                        </td>
                                        <td
                                            style={{
                                                width: "50.8651%",
                                                borderWidth: "medium 1pt 1pt medium",
                                                borderStyle: "none solid solid none",
                                                borderColor:
                                                    "currentcolor rgb(217, 217, 217) rgb(217, 217, 217) currentcolor",
                                                padding: "0cm 5.4pt"
                                            }}
                                        >
                                            <p
                                                style={{
                                                    margin: "0cm 0cm 4pt",
                                                    lineHeight: "110%",
                                                    textAlign: "justify",
                                                    fontSize: "12pt",
                                                    fontFamily: '"Times New Roman", serif',
                                                    color: "black"
                                                }}
                                            >
                                                <span style={{ lineHeight: "110%", fontSize: "13pt" }}>
                                                    Liên hệ hoạt động phạm tội hoặc chủ thể trong Danh sách cảnh báo
                                                </span>
                                            </p>
                                        </td>
                                        <td
                                            style={{
                                                width: "32.8944%",
                                                borderWidth: "medium 1pt 1pt medium",
                                                borderStyle: "none solid solid none",
                                                borderColor:
                                                    "currentcolor rgb(217, 217, 217) rgb(217, 217, 217) currentcolor",
                                                padding: "0cm 5.4pt"
                                            }}
                                        >
                                            <p
                                                style={{
                                                    margin: "0cm 0cm 4pt",
                                                    lineHeight: "110%",
                                                    textAlign: "justify",
                                                    fontSize: "12pt",
                                                    fontFamily: '"Times New Roman", serif',
                                                    color: "black"
                                                }}
                                            >
                                                <span style={{ lineHeight: "110%", fontSize: "13pt" }}>
                                                    CB08, CB09
                                                </span>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr style={{ pageBreakInside: "avoid" }}>
                                        <td
                                            style={{
                                                width: "16.2405%",
                                                borderWidth: "medium 1pt 1pt",
                                                borderStyle: "none solid solid",
                                                borderColor: "currentcolor rgb(217, 217, 217) rgb(217, 217, 217)",
                                                padding: "0cm 5.4pt"
                                            }}
                                        >
                                            <p
                                                style={{
                                                    margin: "0cm 0cm 4pt",
                                                    lineHeight: "110%",
                                                    textAlign: "justify",
                                                    fontSize: "12pt",
                                                    fontFamily: '"Times New Roman", serif',
                                                    color: "black"
                                                }}
                                            >
                                                <span style={{ lineHeight: "110%", fontSize: "13pt" }}>7</span>
                                            </p>
                                        </td>
                                        <td
                                            style={{
                                                width: "50.8651%",
                                                borderWidth: "medium 1pt 1pt medium",
                                                borderStyle: "none solid solid none",
                                                borderColor:
                                                    "currentcolor rgb(217, 217, 217) rgb(217, 217, 217) currentcolor",
                                                padding: "0cm 5.4pt"
                                            }}
                                        >
                                            <p
                                                style={{
                                                    margin: "0cm 0cm 4pt",
                                                    lineHeight: "110%",
                                                    textAlign: "justify",
                                                    fontSize: "12pt",
                                                    fontFamily: '"Times New Roman", serif',
                                                    color: "black"
                                                }}
                                            >
                                                <span style={{ lineHeight: "110%", fontSize: "13pt" }}>
                                                    Giao dịch lớn không phù hợp thu nhập hoặc hoạt động kinh doanh
                                                </span>
                                            </p>
                                        </td>
                                        <td
                                            style={{
                                                width: "32.8944%",
                                                borderWidth: "medium 1pt 1pt medium",
                                                borderStyle: "none solid solid none",
                                                borderColor:
                                                    "currentcolor rgb(217, 217, 217) rgb(217, 217, 217) currentcolor",
                                                padding: "0cm 5.4pt"
                                            }}
                                        >
                                            <p
                                                style={{
                                                    margin: "0cm 0cm 4pt",
                                                    lineHeight: "110%",
                                                    textAlign: "justify",
                                                    fontSize: "12pt",
                                                    fontFamily: '"Times New Roman", serif',
                                                    color: "black"
                                                }}
                                            >
                                                <span style={{ lineHeight: "110%", fontSize: "13pt" }}>
                                                    CB10, CB11
                                                </span>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr style={{ pageBreakInside: "avoid" }}>
                                        <td
                                            style={{
                                                width: "16.2405%",
                                                borderWidth: "medium 1pt 1pt",
                                                borderStyle: "none solid solid",
                                                borderColor: "currentcolor rgb(217, 217, 217) rgb(217, 217, 217)",
                                                padding: "0cm 5.4pt"
                                            }}
                                        >
                                            <p
                                                style={{
                                                    margin: "0cm 0cm 4pt",
                                                    lineHeight: "110%",
                                                    textAlign: "justify",
                                                    fontSize: "12pt",
                                                    fontFamily: '"Times New Roman", serif',
                                                    color: "black"
                                                }}
                                            >
                                                <span style={{ lineHeight: "110%", fontSize: "13pt" }}>8</span>
                                            </p>
                                        </td>
                                        <td
                                            style={{
                                                width: "50.8651%",
                                                borderWidth: "medium 1pt 1pt medium",
                                                borderStyle: "none solid solid none",
                                                borderColor:
                                                    "currentcolor rgb(217, 217, 217) rgb(217, 217, 217) currentcolor",
                                                padding: "0cm 5.4pt"
                                            }}
                                        >
                                            <p
                                                style={{
                                                    margin: "0cm 0cm 4pt",
                                                    lineHeight: "110%",
                                                    textAlign: "justify",
                                                    fontSize: "12pt",
                                                    fontFamily: '"Times New Roman", serif',
                                                    color: "black"
                                                }}
                                            >
                                                <span style={{ lineHeight: "110%", fontSize: "13pt" }}>
                                                    Yêu cầu sai trình tự thủ tục pháp luật
                                                </span>
                                            </p>
                                        </td>
                                        <td
                                            style={{
                                                width: "32.8944%",
                                                borderWidth: "medium 1pt 1pt medium",
                                                borderStyle: "none solid solid none",
                                                borderColor:
                                                    "currentcolor rgb(217, 217, 217) rgb(217, 217, 217) currentcolor",
                                                padding: "0cm 5.4pt"
                                            }}
                                        >
                                            <p
                                                style={{
                                                    margin: "0cm 0cm 4pt",
                                                    lineHeight: "110%",
                                                    textAlign: "justify",
                                                    fontSize: "12pt",
                                                    fontFamily: '"Times New Roman", serif',
                                                    color: "black"
                                                }}
                                            >
                                                <span style={{ lineHeight: "110%", fontSize: "13pt" }}>CB12</span>
                                            </p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <h3
                                style={{
                                    margin: "8pt 0cm 6pt",
                                    textAlign: "left",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                                align="left"
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    CB01 Từ chối cung cấp thông tin nhận biết khách hàng
                                </span>
                            </h3>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Căn cứ đối chiếu: Khoản 1 Điều 27 Luật PCRT. Phạm vi: khách hàng, bên giao
                                    dịch hoặc chủ thể liên quan phù hợp vai trò cung ứng dịch vụ của Công ty.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện nhận diện: Khách hàng từ chối cung cấp thông tin KYC cần thiết,
                                    từ chối giải thích hoặc xác minh thông tin thuộc phạm vi yêu cầu hợp pháp
                                    của Công ty. Một lần từ chối rõ ràng đã đủ tạo cảnh báo; không cần đợi hết
                                    thời hạn hoặc nhiều lần nhắc.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Dữ liệu và bằng chứng: Lưu yêu cầu, mục đích thu thập, kênh gửi, phản hồi
                                    nguyên văn và trường dữ liệu còn thiếu. Kiểm tra yêu cầu có đúng đối
                                    tượng, cần thiết, rõ ràng và có phương thức cung cấp khả thi hay không.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xử lý và ưu tiên: Vận hành chuyển PCRT mức P2; thực hiện chính sách chấp
                                    nhận khách hàng và quy trình KYC đối với trường hợp không thể hoàn tất
                                    nhận biết. PCRT đánh giá lý do từ chối, giao dịch liên quan và cơ sở báo
                                    cáo; không coi mọi từ chối là đã đủ kết luận rửa tiền.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Đối chiếu bối cảnh: Khách hàng yêu cầu giải thích việc dùng dữ liệu hoặc
                                    gặp lỗi tải tài liệu khác với từ chối nhận biết. Lưu bằng chứng lỗi và hỗ
                                    trợ phù hợp; không dùng nhãn lỗi kỹ thuật để đóng vụ việc chưa xác minh.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Người mở ví yêu cầu bỏ qua thông tin nghề nghiệp và
                                    nguồn tiền khi đang thực hiện một chuỗi nạp rút bất thường; lập CB01 và
                                    liên kết TG02.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "8pt 0cm 6pt",
                                    textAlign: "left",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                                align="left"
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    CB02 Thông tin nhận biết không chính xác không đầy đủ hoặc không nhất quán
                                </span>
                            </h3>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Căn cứ đối chiếu: Khoản 1 Điều 27 Luật PCRT. Phạm vi: khách hàng, bên giao
                                    dịch hoặc chủ thể liên quan phù hợp vai trò cung ứng dịch vụ của Công ty.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện nhận diện: Có thông tin KYC sai, thiếu hoặc mâu thuẫn giữa hồ
                                    sơ, lời khai, dữ liệu xác minh và thông tin cập nhật. Không đặt ngưỡng số
                                    trường sai; một mâu thuẫn trọng yếu về danh tính hoặc chủ thể kiểm soát đã
                                    cần rà soát.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Dữ liệu và bằng chứng: So sánh hồ sơ tại ngày mở quan hệ và tại thời điểm
                                    giao dịch; ghi từng trường sai khác, nguồn đối chiếu, ngày kiểm tra và độ
                                    tin cậy. Phân biệt lỗi nhập liệu với tài liệu bị sửa hoặc thông tin khai
                                    không đúng.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xử lý và ưu tiên: Chuyển P2 nếu mâu thuẫn ảnh hưởng nhận diện chủ thể,
                                    quyền đại diện hoặc nguồn tiền. Yêu cầu sửa và xác minh qua quy trình KYC;
                                    nếu có dấu hiệu giả mạo đang dẫn đến chuyển tiền, chuyển PCRT và tuyến
                                    gian lận ngay.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Đối chiếu bối cảnh: Đổi địa chỉ, số giấy tờ hoặc cơ cấu sở hữu có thể hợp
                                    pháp nhưng phải có tài liệu và cập nhật. Chưa xác minh xong thì giữ trạng
                                    thái chờ; không tự kết luận thông tin đã đúng chỉ từ bản khai mới.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Khách hàng khai là người sử dụng nhưng hợp đồng, số
                                    liên hệ và hướng dẫn chuyển tiền đều thuộc người khác; xem xét CB02 cùng
                                    TG19.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "8pt 0cm 6pt",
                                    textAlign: "left",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                                align="left"
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    CB03 Thuyết phục Công ty không báo cáo giao dịch
                                </span>
                            </h3>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Căn cứ đối chiếu: Khoản 2 Điều 27 Luật PCRT. Phạm vi: khách hàng, bên giao
                                    dịch hoặc chủ thể liên quan phù hợp vai trò cung ứng dịch vụ của Công ty.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện nhận diện: Khách hàng trực tiếp hoặc qua người đại diện đề nghị,
                                    gây sức ép, hứa lợi ích hoặc đưa điều kiện nhằm khiến Công ty không báo
                                    cáo giao dịch cho cơ quan có thẩm quyền. Một sự kiện có nội dung rõ ràng
                                    đủ kích hoạt; không phụ thuộc số tiền.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Dữ liệu và bằng chứng: Lưu thư, tin nhắn, nội dung cuộc gọi hoặc biên bản
                                    làm việc được thu thập hợp pháp; ghi người nói, vai trò, thời gian và giao
                                    dịch được nhắc đến. Không hỏi gợi ý nhằm tạo lời thừa nhận.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xử lý và ưu tiên: Chuyển PCRT mức P2 ngay; nâng P1 khi kèm thông tin đáng
                                    tin cậy về tội phạm hoặc giao dịch cần xử lý khẩn. Nhân viên không thương
                                    lượng về nghĩa vụ báo cáo và không tiết lộ việc Công ty đã hoặc sẽ báo
                                    cáo.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Đối chiếu bối cảnh: Câu hỏi chung về bảo mật dữ liệu hoặc thủ tục báo cáo
                                    chưa tự đồng nghĩa với yêu cầu né báo cáo. Cần ghi đúng câu nói và bối
                                    cảnh; phân biệt với thắc mắc về quyền lợi khách hàng.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Khách hàng đề nghị trả thêm phí nếu nhân viên không
                                    đưa giao dịch vào báo cáo; lập CB03 và bảo toàn nội dung trao đổi.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "8pt 0cm 6pt",
                                    textAlign: "left",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                                align="left"
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    CB04 Không xác định được khách hàng từ thông tin cung cấp
                                </span>
                            </h3>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Căn cứ đối chiếu: Khoản 3 Điều 27 Luật PCRT. Phạm vi: khách hàng, bên giao
                                    dịch hoặc chủ thể liên quan phù hợp vai trò cung ứng dịch vụ của Công ty.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện nhận diện: Sau đối chiếu qua nguồn và phương thức phù hợp, Công
                                    ty không xác định được khách hàng từ thông tin họ cung cấp; hoặc thông tin
                                    nhận diện không đủ để xác minh. Kích hoạt khi phát hiện trở ngại thực
                                    chất, không chờ một số lần thử cố định.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Dữ liệu và bằng chứng: Lưu dữ liệu đầu vào, phương thức xác minh, kết quả
                                    đối chiếu và nguyên nhân. Nếu nguồn xác minh gián đoạn, ghi sự cố riêng và
                                    kiểm tra lại; không biến sự cố kỹ thuật thành kết luận danh tính không tồn
                                    tại.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xử lý và ưu tiên: Chuyển P2, phối hợp KYC để xử lý điều kiện cung ứng dịch
                                    vụ. PCRT đánh giá giao dịch đã có hoặc đang được yêu cầu, người điều khiển
                                    và cơ sở báo cáo khi không thể hoàn tất nhận biết và có nghi ngờ.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Đối chiếu bối cảnh: Không coi xác thực OTP thành công là đã xác minh toàn
                                    bộ danh tính. Các giấy tờ khác nhau do cập nhật hợp pháp phải được đối
                                    chiếu theo quy trình nhận biết.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Số định danh, họ tên và ngày sinh không khớp nguồn
                                    kiểm tra đáng tin cậy, khách hàng không giải thích được; lập CB04.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "8pt 0cm 6pt",
                                    textAlign: "left",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                                align="left"
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    CB05 Giao dịch liên quan đến bên không xác định được danh tính
                                </span>
                            </h3>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Căn cứ đối chiếu: Khoản 3 Điều 27 Luật PCRT. Phạm vi: khách hàng, bên giao
                                    dịch hoặc chủ thể liên quan phù hợp vai trò cung ứng dịch vụ của Công ty.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện nhận diện: Có giao dịch hoặc yêu cầu giao dịch mà một bên liên
                                    quan không xác định được danh tính từ thông tin Công ty có hoặc thu thập
                                    được hợp pháp. Áp dụng cho bên gửi, nhận, người ra lệnh, đại diện hoặc chủ
                                    thể hưởng lợi phù hợp vai trò quan sát.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Dữ liệu và bằng chứng: Kiểm tra mã giao dịch, tên, tài khoản hoặc mã định
                                    danh đối ứng và thông tin do đối tác cung cấp. Ghi rõ thiếu trường gì,
                                    phạm vi dữ liệu Công ty được thấy và phần cần ngân hàng hoặc đối tác phối
                                    hợp.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xử lý và ưu tiên: Chuyển P2; áp dụng quy trình kiểm soát thông tin lệnh
                                    thanh toán và yêu cầu bổ sung qua kênh hợp pháp. Nếu chỉ có giới hạn dữ
                                    liệu ngoài hệ thống, hồ sơ phải phản ánh giới hạn đó; tiếp tục đánh giá
                                    các dấu hiệu khác.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Đối chiếu bối cảnh: Không suy diễn rằng mọi đối ứng ngoài hệ thống đều
                                    không có danh tính. Không yêu cầu nhân viên truy cập dữ liệu ngân hàng
                                    ngoài quyền được cấp hoặc tự liên hệ trái phạm vi bảo mật.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Lệnh thanh toán có người hưởng hiển thị không xác
                                    định, bên cung cấp dữ liệu không làm rõ được, kèm chuỗi tiền trung chuyển;
                                    lập CB05 và TG09.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "8pt 0cm 6pt",
                                    textAlign: "left",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                                align="left"
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    CB06 Số điện thoại không liên lạc được hoặc không tồn tại
                                </span>
                            </h3>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Căn cứ đối chiếu: Khoản 4 Điều 27 Luật PCRT. Phạm vi: khách hàng, bên giao
                                    dịch hoặc chủ thể liên quan phù hợp vai trò cung ứng dịch vụ của Công ty.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện nhận diện: Sau khi mở tài khoản hoặc thực hiện giao dịch, số
                                    điện thoại khách hàng cung cấp không thể liên lạc hoặc được xác định không
                                    tồn tại. Tạo cảnh báo ngay khi có dấu hiệu; việc gọi lại dùng để xác minh,
                                    không phải điều kiện trì hoãn tiếp nhận.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Dữ liệu và bằng chứng: Lưu thời điểm, số đã liên hệ theo quyền được cấp,
                                    kết quả cuộc gọi và thông báo nhà mạng nếu có. Đề xuất xác minh tối đa 3
                                    lần tại các thời điểm khác nhau trong 2 ngày làm việc và kiểm tra kênh đã
                                    đăng ký khác; đây là mục tiêu nội bộ, không dừng hạn báo cáo.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xử lý và ưu tiên: Ưu tiên P3 khi chỉ có mất liên lạc, nâng P2 khi kèm
                                    CB02, CB04 hoặc dòng tiền bất thường. Số không tồn tại đã được xác minh
                                    thì chuyển PCRT không cần chờ đủ số lần thử.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Đối chiếu bối cảnh: Điện thoại tắt, roaming, ngoài vùng phủ sóng, nhập sai
                                    số hoặc đổi số có thể giải thích hợp pháp. Đối chiếu nhật ký thay đổi và
                                    xác thực; không nhận số mới từ người không chứng minh được tư cách.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Ví nhận tiền rồi không thể liên hệ số đã đăng ký, dữ
                                    liệu KYC cũng mâu thuẫn; mở cùng một hồ sơ CB06 và CB02.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "8pt 0cm 6pt",
                                    textAlign: "left",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                                align="left"
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    CB07 Lệnh hoặc ủy quyền của chủ thể trong Danh sách cảnh báo
                                </span>
                            </h3>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Căn cứ đối chiếu: Khoản 5 Điều 27 Luật PCRT. Phạm vi: khách hàng, bên giao
                                    dịch hoặc chủ thể liên quan phù hợp vai trò cung ứng dịch vụ của Công ty.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện nhận diện: Giao dịch được thực hiện theo lệnh hoặc ủy quyền của
                                    chủ thể có trong Danh sách cảnh báo do NHNN lập. Rà soát cả người đứng tên
                                    và người thực tế ra lệnh hoặc ủy quyền theo thông tin được thu thập; không
                                    đặt ngưỡng tiền.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Dữ liệu và bằng chứng: Lưu tên danh sách, nguồn chính thức, phiên bản,
                                    ngày cập nhật, bản ghi đối sánh, giấy ủy quyền và liên hệ với giao dịch.
                                    Đối chiếu nhiều thuộc tính định danh có sẵn; trùng tên đơn thuần là kết
                                    quả cần xác minh.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xử lý và ưu tiên: Kết quả đối sánh có khả năng đúng chuyển P2 ngay; khi
                                    xác minh được quan hệ và giao dịch trọng yếu, PCRT quyết định tăng ưu tiên
                                    theo chứng cứ. Rà soát phạm vi ủy quyền, mục đích và tài sản; đánh giá
                                    nghĩa vụ báo cáo.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Đối chiếu bối cảnh: Danh sách cảnh báo khác Danh sách đen và thông tin bất
                                    lợi trên báo chí. Việc thuộc Danh sách cảnh báo không tự tạo căn cứ phong
                                    tỏa hoặc trì hoãn; nếu đồng thời có căn cứ khác, xử lý theo quy trình biện
                                    pháp tạm thời.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Khách hàng đứng tên không nằm trong danh sách nhưng
                                    người ủy quyền giao dịch có bản ghi đối sánh đã xác minh; lập CB07.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "8pt 0cm 6pt",
                                    textAlign: "left",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                                align="left"
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    CB08 Mối liên hệ giữa giao dịch và hoạt động phạm tội
                                </span>
                            </h3>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Căn cứ đối chiếu: Khoản 6 Điều 27 Luật PCRT. Phạm vi: khách hàng, bên giao
                                    dịch hoặc chủ thể liên quan phù hợp vai trò cung ứng dịch vụ của Công ty.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện nhận diện: Thông tin KYC hoặc phân tích cơ sở kinh tế, pháp lý
                                    cho thấy mối liên hệ giữa bên tham gia giao dịch và hoạt động phạm tội.
                                    Một liên hệ có chứng cứ đủ để mở hồ sơ; không giới hạn vào ví hoặc giao
                                    dịch có số tiền lớn.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Dữ liệu và bằng chứng: Lưu thông tin cơ quan có thẩm quyền, tài liệu giao
                                    dịch, thông tin đối tác và nguồn công khai đáng tin cậy. Xác định bên nào,
                                    hành vi nào, quan hệ với tiền và căn cứ từng nhận định; tách sự kiện xác
                                    nhận khỏi nghi vấn.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xử lý và ưu tiên: Chuyển P1 khi có liên hệ đáng tin cậy cần xử lý khẩn;
                                    PCRT kiểm tra điều kiện báo cáo, thời hạn 24 giờ khi thuộc trường hợp luật
                                    định và căn cứ biện pháp tạm thời nếu có. Không chờ khách hàng hoàn tất
                                    giải trình khi nghĩa vụ đã phát sinh.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Đối chiếu bối cảnh: Một bài báo chưa xác minh hoặc giao dịch từng phát
                                    sinh với người bị nêu tên không đủ để kết luận khách hàng phạm tội. Đánh
                                    giá quan hệ cụ thể, thời gian và nguồn tài sản; không quy kết cho toàn bộ
                                    mạng lưới.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Có thông tin xác thực về bên nhận và giao dịch liên
                                    quan hoạt động phạm tội, tiền được chuyển tiếp qua ví; lập CB08 cùng TG17
                                    nếu phù hợp.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "8pt 0cm 6pt",
                                    textAlign: "left",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                                align="left"
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    CB09 Liên hệ với chủ thể thuộc Danh sách cảnh báo
                                </span>
                            </h3>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Căn cứ đối chiếu: Khoản 6 Điều 27 Luật PCRT. Phạm vi: khách hàng, bên giao
                                    dịch hoặc chủ thể liên quan phù hợp vai trò cung ứng dịch vụ của Công ty.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện nhận diện: Qua hồ sơ hoặc phân tích giao dịch có thể xác định
                                    liên hệ của bên tham gia với chủ thể thuộc Danh sách cảnh báo, kể cả khi
                                    không có lệnh hoặc ủy quyền trực tiếp. Phân biệt với CB07 để xác định đúng
                                    vai trò.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Dữ liệu và bằng chứng: Xác minh định danh chủ thể trong danh sách và loại
                                    liên hệ: đối ứng, sở hữu, kiểm soát, đại diện hoặc nguồn tiền. Lưu đồ thị
                                    khi cần và chỉ rõ cạnh nào có chứng cứ; không suy rộng chỉ vì cùng địa chỉ
                                    hoặc cùng IP.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xử lý và ưu tiên: Chuyển P2; rà soát mục đích giao dịch và yếu tố tăng
                                    hoặc giảm nghi ngờ. Khi có liên hệ tội phạm đáng tin cậy chuyển đồng thời
                                    CB08. Việc mở hoặc tiếp tục quan hệ khách hàng theo phân quyền rủi ro và
                                    chính sách chấp nhận.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Đối chiếu bối cảnh: Quan hệ gia đình, địa chỉ chung hoặc giao dịch thương
                                    mại có thể hợp pháp. Danh sách theo dõi nội bộ hoặc danh sách nước ngoài
                                    phải ghi tên nguồn riêng, không tự gọi là Danh sách cảnh báo của NHNN.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Người hưởng lợi thực tế có liên hệ kiểm soát đã xác
                                    minh với chủ thể trong danh sách; lập CB09 dù người đứng tên ví không
                                    trùng danh sách.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "8pt 0cm 6pt",
                                    textAlign: "left",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                                align="left"
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    CB10 Giao dịch lớn không phù hợp thu nhập của cá nhân
                                </span>
                            </h3>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Căn cứ đối chiếu: Khoản 7 Điều 27 Luật PCRT. Phạm vi: khách hàng, bên giao
                                    dịch hoặc chủ thể liên quan phù hợp vai trò cung ứng dịch vụ của Công ty.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện nhận diện: Giao dịch lớn hoặc mức giao dịch trong kỳ không phù
                                    hợp thu nhập, nguồn tài sản và hoạt động của cá nhân. Đề xuất hỗ trợ tự
                                    động: một giao dịch hoặc doanh số ra 30 ngày đạt từ 5 lần thu nhập tháng
                                    đã xác minh; cần phân tích bối cảnh, không coi tỷ lệ này là ngưỡng pháp
                                    lý.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Dữ liệu và bằng chứng: Đối chiếu nguồn thu, bán tài sản, tiền tiết kiệm,
                                    vay, tặng cho hoặc các nguồn hợp pháp khác có chứng từ. Nếu thu nhập chưa
                                    có hoặc bằng 0, không chia cho 0 và không kết luận tự động; chuyển đánh
                                    giá thủ công khi có giao dịch lớn theo nhóm tương đồng.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xử lý và ưu tiên: Chuyển P2 khi chênh lệch trọng yếu không có giải thích
                                    phù hợp; P3 khi mới chỉ vượt tham số hỗ trợ. Lưu cách tính và tránh cộng
                                    cả tiền vào lẫn ra hoặc cộng lặp tài sản trung chuyển để suy ra thu nhập.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Đối chiếu bối cảnh: Thu nhập tháng thấp không có nghĩa khách hàng không có
                                    tiết kiệm hoặc tài sản. Tiền bán nhà, di sản hay tài trợ phải được xem xét
                                    theo nguồn thực tế; chứng từ giả hoặc mâu thuẫn chuyển thêm CB02.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Thu nhập xác minh 8 triệu/tháng nhưng yêu cầu chuyển
                                    60 triệu, không làm rõ nguồn tiền; lập CB10 và TG14 nếu cũng thỏa điều
                                    kiện.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "8pt 0cm 6pt",
                                    textAlign: "left",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                                align="left"
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    CB11 Giao dịch lớn không phù hợp hoạt động kinh doanh của tổ chức
                                </span>
                            </h3>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Căn cứ đối chiếu: Khoản 7 Điều 27 Luật PCRT. Phạm vi: khách hàng, bên giao
                                    dịch hoặc chủ thể liên quan phù hợp vai trò cung ứng dịch vụ của Công ty.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện nhận diện: Giá trị và bản chất giao dịch không phù hợp ngành
                                    nghề, quy mô, doanh thu, dòng tiền và mục đích sử dụng của tổ chức. Đề
                                    xuất hỗ trợ: doanh số 30 ngày từ 3 lần doanh thu tháng kỳ so sánh đã xác
                                    minh; có sai khác về bản chất thì cảnh báo dù chưa vượt tỷ lệ.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Dữ liệu và bằng chứng: Đối chiếu báo cáo doanh thu, hợp đồng, đơn hàng,
                                    hóa đơn, tài sản và nguồn vốn; tách doanh thu với tiền vay, tăng vốn hoặc
                                    bán tài sản. Lựa chọn kỳ so sánh theo mùa vụ; doanh nghiệp mới dùng kế
                                    hoạch và tài liệu thực tế được kiểm tra.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xử lý và ưu tiên: Chuyển P2 khi không có cơ sở kinh tế phù hợp; PCRT phối
                                    hợp bộ phận ĐVCNTT và xác minh nguồn, mục đích, người hưởng lợi. Nếu Công
                                    ty không cung ứng ví tổ chức, áp dụng qua hồ sơ ĐVCNTT hoặc khách hàng tổ
                                    chức trong phạm vi dịch vụ được phép.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Đối chiếu bối cảnh: Không đồng nhất luân chuyển tiền với doanh thu kế
                                    toán. Hoạt động chi hộ được phép, mùa cao điểm, tiền ứng trước hoặc tài
                                    trợ vốn có thể giải thích; phải kiểm tra quyền thực hiện và tài liệu.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: ĐVCNTT có doanh thu ổn định 50 triệu/tháng nhưng nhận
                                    250 triệu từ các giao dịch không có đơn hàng phù hợp; lập CB11, xem thêm
                                    TG22 hoặc TG29.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "8pt 0cm 6pt",
                                    textAlign: "left",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                                align="left"
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    CB12 Yêu cầu giao dịch sai trình tự thủ tục pháp luật
                                </span>
                            </h3>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Căn cứ đối chiếu: Khoản 8 Điều 27 Luật PCRT. Phạm vi: khách hàng, bên giao
                                    dịch hoặc chủ thể liên quan phù hợp vai trò cung ứng dịch vụ của Công ty.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện nhận diện: Khách hàng đề nghị bỏ qua hoặc thay đổi bước bắt buộc
                                    theo pháp luật: dùng sai chủ thể, bỏ xác minh cần thiết, dùng chứng từ
                                    không đúng hoặc thực hiện dịch vụ ngoài điều kiện được phép. Một yêu cầu
                                    rõ ràng đủ tạo cảnh báo; không phụ thuộc giá trị.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Dữ liệu và bằng chứng: Ghi yêu cầu, quy định pháp luật liên quan, bước bắt
                                    buộc và người tiếp nhận. Pháp chế xác định căn cứ cụ thể; phân biệt thủ
                                    tục luật định với lựa chọn dịch vụ hoặc yêu cầu nội bộ có thể thay đổi hợp
                                    pháp.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xử lý và ưu tiên: Không chấp nhận yêu cầu trái pháp luật; chuyển PCRT mức
                                    P2 và thực hiện quy trình từ chối hoặc kiểm soát nghiệp vụ phù hợp. Đánh
                                    giá cơ sở nghi ngờ và báo cáo độc lập với quyết định từ chối.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Đối chiếu bối cảnh: Việc xin hỗ trợ thao tác, thay lịch hoặc đề nghị quy
                                    trình nhanh hơn chưa tự là dấu hiệu khoản 8 nếu vẫn đáp ứng pháp luật.
                                    Không hướng dẫn chia nhỏ hoặc dùng người đứng tên khác để vượt điều kiện.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Khách đề nghị dùng ví người khác để thực hiện giao
                                    dịch nhằm bỏ qua bước xác minh bắt buộc; lập CB12 và TG19 khi có bằng
                                    chứng sử dụng thay.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "8pt 0cm 6pt",
                                    textAlign: "center",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                                align="center"
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    PHÂN CÔNG VẬN HÀNH BỘ TIÊU CHÍ CƠ BẢN
                                </span>
                            </h3>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    KYC và Vận hành tiếp nhận CB01, CB02, CB04, CB05, CB06; mọi nhân viên tiếp
                                    xúc khách hàng tiếp nhận CB03 và CB12; PCRT chủ trì đối sánh danh sách,
                                    xác minh quan hệ CB07–CB09 và phân tích năng lực tài chính CB10–CB11. Kinh
                                    doanh, bộ phận ĐVCNTT, Công nghệ và ngân hàng đối tác phối hợp trong phạm
                                    vi nhiệm vụ và quyền dữ liệu. Trách nhiệm xử lý cuối cùng theo phân quyền
                                    tại Chương I và Chương III.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    PCRT rà soát CB01–CB12 trong mọi hồ sơ đáng ngờ, ghi kết quả từng nhóm
                                    liên quan, không tích mặc định toàn bộ là không áp dụng. Khi một sự kiện
                                    trùng CB và TG, lập một hồ sơ, giữ toàn bộ mã và mốc phát hiện gốc; không
                                    cộng điểm trùng cho cùng chứng cứ hoặc báo cáo nhiều lần chỉ do trùng mã.
                                </span>
                            </p>
                            <h2
                                style={{
                                    margin: "8pt 0cm 6pt",
                                    textAlign: "center",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                                align="center"
                            >
                                <span style={{ fontSize: "13pt" }}>
                                    <a name="_Toc242576916" />
                                    <span style={{ lineHeight: "115%" }}>
                                        MỤC 2<br />
                                        BỘ TIÊU CHÍ CHUYÊN BIỆT THEO ĐIỀU 29 LUẬT PCRT
                                    </span>
                                </span>
                            </h2>
                            <h2
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "left",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                                align="left"
                            >
                                <span style={{ fontSize: "13pt" }}>
                                    <a name="_Toc242576917" />
                                    <span style={{ lineHeight: "115%" }}>
                                        Nhóm 1 Doanh số đột biến và dòng tiền nhanh
                                    </span>
                                </span>
                            </h2>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Chương II Bộ tiêu chí nhận diện • Căn cứ đối chiếu Khoản 1 Điều 29. Các
                                    con số dưới đây là tham số khởi tạo đề xuất, chưa phải mức bắt buộc của
                                    pháp luật. Cảnh báo thủ công vẫn được lập khi có cơ sở nghi ngờ ngoài điều
                                    kiện định lượng.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    TG01 Doanh số tăng đột biến
                                </span>
                            </h3>
                            <p
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textIndent: "22.7pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện phát hiện: I hoặc O trong 24 giờ ≥ 5 × B30 và ≥ 20 triệu đồng;
                                    hoặc vượt P99 của nhóm tương đồng khi không đủ lịch sử.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xác minh và bằng chứng: Kiểm tra thay đổi nghề nghiệp, bán tài sản, chiến
                                    dịch và dữ liệu hoàn tiền. Trích 30 ngày giao dịch và so sánh đúng nhóm
                                    sản phẩm.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Ví thường vào 1 triệu/ngày, nay vào 25 triệu từ nhiều
                                    bên rồi chuyển ra; tạo cảnh báo, kiểm tra nguồn và mục đích. Mức ưu tiên
                                    ban đầu: P3.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    TG02 Nạp vào và rút hoặc chuyển ra nhanh
                                </span>
                            </h3>
                            <p
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textIndent: "22.7pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện phát hiện: I trong 60 phút ≥ 10 triệu đồng và O trong cùng cửa
                                    sổ đạt ≥ 80% I; có ít nhất một giao dịch ra sau giao dịch vào.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xác minh và bằng chứng: Dựng chuỗi theo thời gian; kiểm tra số dư có sẵn,
                                    nghĩa vụ thanh toán, đối ứng và vòng lặp. Tăng ưu tiên nếu lặp ≥ 3 lần
                                    trong 7 ngày.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Nhận 15 triệu, sau 12 phút rút 14 triệu; cần xác minh
                                    vì có thể là nhu cầu hợp pháp. Mức ưu tiên ban đầu: P3.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Hồ sơ phải lưu mã giao dịch, phạm vi thời gian, phiên bản tham số và kết
                                    quả đối chiếu bối cảnh. Chỉ đóng khi có chứng cứ phù hợp; nếu chưa đủ dữ
                                    liệu, giữ trạng thái chờ xác minh và theo dõi hạn báo cáo.
                                </span>
                            </p>
                            <h2
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "left",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                                align="left"
                            >
                                <span style={{ fontSize: "13pt" }}>
                                    <a name="_Toc242576918" />
                                    <span style={{ lineHeight: "115%" }}>
                                        Nhóm 1 Số dư nhỏ so với luân chuyển
                                    </span>
                                </span>
                            </h2>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Chương II Bộ tiêu chí nhận diện • Căn cứ đối chiếu Khoản 1 Điều 29. Các
                                    con số dưới đây là tham số khởi tạo đề xuất, chưa phải mức bắt buộc của
                                    pháp luật. Cảnh báo thủ công vẫn được lập khi có cơ sở nghi ngờ ngoài điều
                                    kiện định lượng.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    TG03 Doanh số lớn nhưng số dư thấp
                                </span>
                            </h3>
                            <p
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textIndent: "22.7pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện phát hiện: I ngày ≥ 30 triệu đồng; O ngày ≥ 90% I; số dư cuối
                                    ngày ≤ 1% I hoặc bằng 0.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xác minh và bằng chứng: Kiểm tra thêm số dư theo thời điểm, tần suất lặp
                                    và dòng thanh toán thực. Giữ cảnh báo khi khách hàng không có hoạt động
                                    tiêu dùng phù hợp.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Ví vào 40 triệu, ra 39,8 triệu, cuối ngày 0,2 triệu;
                                    rà soát cả số dư đầu ngày để hiểu bản chất. Mức ưu tiên ban đầu: P3.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    TG04 Lặp lại mô hình trung chuyển
                                </span>
                            </h3>
                            <p
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textIndent: "22.7pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện phát hiện: TG02 hoặc TG03 xuất hiện trong ≥ 3 ngày của 7 ngày
                                    trượt và không có chứng từ phù hợp hồ sơ.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xác minh và bằng chứng: Tổng hợp một hồ sơ 7 ngày; kiểm tra nguồn, người
                                    nhận và kết nối với các ví khác. Không cộng lại cùng khoản tiền qua các
                                    chặng để kết luận giá trị tài sản.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Ví mới duy trì chuỗi nạp rút nhanh bốn ngày, dùng
                                    cùng một người nhận; chuyển ưu tiên cao. Mức ưu tiên ban đầu: P2.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Hồ sơ phải lưu mã giao dịch, phạm vi thời gian, phiên bản tham số và kết
                                    quả đối chiếu bối cảnh. Chỉ đóng khi có chứng cứ phù hợp; nếu chưa đủ dữ
                                    liệu, giữ trạng thái chờ xác minh và theo dõi hạn báo cáo.
                                </span>
                            </p>
                            <h2
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "left",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                                align="left"
                            >
                                <span style={{ fontSize: "13pt" }}>
                                    <a name="_Toc242576919" />
                                    <span style={{ lineHeight: "115%" }}>
                                        Nhóm 2 Gom khoản nhỏ và chuyển khoản lớn
                                    </span>
                                </span>
                            </h2>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Chương II Bộ tiêu chí nhận diện • Căn cứ đối chiếu Khoản 2 Điều 29. Các
                                    con số dưới đây là tham số khởi tạo đề xuất, chưa phải mức bắt buộc của
                                    pháp luật. Cảnh báo thủ công vẫn được lập khi có cơ sở nghi ngờ ngoài điều
                                    kiện định lượng.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    TG05 Nạp nhỏ nhiều lần rồi chuyển lớn
                                </span>
                            </h3>
                            <p
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textIndent: "22.7pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện phát hiện: ≥ 10 lần nạp, mỗi lần ≤ 1 triệu đồng trong 24 giờ,
                                    tổng I ≥ 5 triệu; trong 6 giờ sau lần nạp cuối có khoản chuyển hoặc rút ≥
                                    70% tổng I.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xác minh và bằng chứng: Chọn tập nạp theo cùng cửa sổ, tránh đếm trùng khi
                                    cập nhật. Kiểm tra nguồn nạp, chủ tài khoản liên kết và lý do chia nhỏ.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Nạp 12 lần, mỗi lần 0,8 triệu; chuyển 8 triệu sang
                                    một ví khác; xác minh giao dịch kinh tế. Mức ưu tiên ban đầu: P3.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    TG06 Nạp lớn rồi chia thành khoản nhỏ
                                </span>
                            </h3>
                            <p
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textIndent: "22.7pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện phát hiện: Một khoản nạp ≥ 10 triệu đồng, sau đó ≥ 10 khoản
                                    chuyển nhỏ ≤ 1 triệu trong 6 giờ, tổng ra ≥ 70% khoản nạp.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xác minh và bằng chứng: Kiểm tra thanh toán hóa đơn hàng loạt, danh sách
                                    người thụ hưởng, tài liệu được phép chi hộ và bối cảnh ví cá nhân.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Nạp 15 triệu rồi chuyển tới 15 chủ ví; yêu cầu làm rõ
                                    quan hệ và mục đích thay vì mặc nhiên kết luận. Mức ưu tiên ban đầu: P3.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Hồ sơ phải lưu mã giao dịch, phạm vi thời gian, phiên bản tham số và kết
                                    quả đối chiếu bối cảnh. Chỉ đóng khi có chứng cứ phù hợp; nếu chưa đủ dữ
                                    liệu, giữ trạng thái chờ xác minh và theo dõi hạn báo cáo.
                                </span>
                            </p>
                            <h2
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "left",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                                align="left"
                            >
                                <span style={{ fontSize: "13pt" }}>
                                    <a name="_Toc242576920" />
                                    <span style={{ lineHeight: "115%" }}>
                                        Nhóm 3 Gom và phân tán nhiều ví
                                    </span>
                                </span>
                            </h2>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Chương II Bộ tiêu chí nhận diện • Căn cứ đối chiếu Khoản 3 Điều 29. Các
                                    con số dưới đây là tham số khởi tạo đề xuất, chưa phải mức bắt buộc của
                                    pháp luật. Cảnh báo thủ công vẫn được lập khi có cơ sở nghi ngờ ngoài điều
                                    kiện định lượng.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    TG07 Nhiều chủ ví chuyển về một ví
                                </span>
                            </h3>
                            <p
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textIndent: "22.7pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện phát hiện: ≥ 10 chủ ví gửi độc lập trong 60 phút; từng khoản ≤ 1
                                    triệu; tổng nhận ≥ 5 triệu.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xác minh và bằng chứng: Đếm chủ theo mã chuẩn hóa. Kiểm tra thu hộ bán
                                    hàng, đóng góp, doanh thu và giao dịch ra tiếp theo; không miễn trừ chỉ vì
                                    cùng nhóm xã hội.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Mười hai người chuyển 0,5 triệu trong 40 phút, ví
                                    nhận rút ngay; gộp với TG02. Mức ưu tiên ban đầu: P3.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    TG08 Một ví chia tiền tới nhiều chủ ví
                                </span>
                            </h3>
                            <p
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textIndent: "22.7pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện phát hiện: ≥ 10 chủ ví nhận trong 60 phút; từng khoản ≤ 1 triệu;
                                    tổng ra ≥ 5 triệu.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xác minh và bằng chứng: Đối chiếu danh sách chi trả và mục đích đã đăng
                                    ký, hoạt động kinh doanh và dữ liệu xác minh. Tăng ưu tiên khi người nhận
                                    cùng thiết bị.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Một ví cá nhân chuyển 20 khoản đồng mức tới các chủ
                                    khác nhau và không giải thích mục đích. Mức ưu tiên ban đầu: P3.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Hồ sơ phải lưu mã giao dịch, phạm vi thời gian, phiên bản tham số và kết
                                    quả đối chiếu bối cảnh. Chỉ đóng khi có chứng cứ phù hợp; nếu chưa đủ dữ
                                    liệu, giữ trạng thái chờ xác minh và theo dõi hạn báo cáo.
                                </span>
                            </p>
                            <h2
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "left",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                                align="left"
                            >
                                <span style={{ fontSize: "13pt" }}>
                                    <a name="_Toc242576921" />
                                    <span style={{ lineHeight: "115%" }}>
                                        Nhóm 3 Nhiều chặng và chi phí bất hợp lý
                                    </span>
                                </span>
                            </h2>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Chương II Bộ tiêu chí nhận diện • Căn cứ đối chiếu Khoản 3 Điều 29. Các
                                    con số dưới đây là tham số khởi tạo đề xuất, chưa phải mức bắt buộc của
                                    pháp luật. Cảnh báo thủ công vẫn được lập khi có cơ sở nghi ngờ ngoài điều
                                    kiện định lượng.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    TG09 Chuỗi qua nhiều ví
                                </span>
                            </h3>
                            <p
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textIndent: "22.7pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện phát hiện: Quan sát ≥ 3 chặng qua ≥ 4 ví trong 2 giờ; giá trị
                                    mỗi chặng giữ ≥ 80% khoản chặng trước.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xác minh và bằng chứng: Lưu đồ thị và thời gian từng chặng; phân biệt khớp
                                    số tiền với bằng chứng cùng nguồn. Mức độ quan sát bên ngoài phải ghi rõ.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: A chuyển B, B chuyển C, C chuyển D trong 35 phút,
                                    tiền gần bằng nhau, chưa có lý do kinh tế. Mức ưu tiên ban đầu: P2.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    TG10 Chuyển vòng quay lại
                                </span>
                            </h3>
                            <p
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textIndent: "22.7pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện phát hiện: Tiền đi từ ví A qua ≥ 2 ví khác và quay lại A trong
                                    24 giờ; tổng nhận lại ≥ 70% khoản A đã gửi.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xác minh và bằng chứng: Xác minh quan hệ các chủ ví, hoàn tiền, thử nghiệm
                                    hoặc thanh toán bị hủy. Không coi chuỗi có số tiền tương tự là chắc chắn
                                    cùng tài sản.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: A đến B đến C đến A với phí phát sinh và không có mua
                                    bán; mở hồ sơ mạng lưới. Mức ưu tiên ban đầu: P2.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    TG11 Chấp nhận phí không phù hợp mục đích
                                </span>
                            </h3>
                            <p
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textIndent: "22.7pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện phát hiện: ≥ 10 giao dịch trong 24 giờ; tổng phí thực trả ≥ 5%
                                    tổng giá trị ra, đồng thời có dòng tiền vòng hoặc trung chuyển.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xác minh và bằng chứng: Đối chiếu biểu phí, phí được hoàn và khuyến mại;
                                    đánh giá khách hàng có lựa chọn ít phí hợp lý hay không. Phí cao riêng lẻ
                                    chưa đủ kết luận.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Giao dịch vòng lặp chịu phí lặp lại mà không tạo hàng
                                    hóa dịch vụ; xác minh động cơ. Mức ưu tiên ban đầu: P2.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Hồ sơ phải lưu mã giao dịch, phạm vi thời gian, phiên bản tham số và kết
                                    quả đối chiếu bối cảnh. Chỉ đóng khi có chứng cứ phù hợp; nếu chưa đủ dữ
                                    liệu, giữ trạng thái chờ xác minh và theo dõi hạn báo cáo.
                                </span>
                            </p>
                            <h2
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "left",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                                align="left"
                            >
                                <span style={{ fontSize: "13pt" }}>
                                    <a name="_Toc242576922" />
                                    <span style={{ lineHeight: "115%" }}>
                                        Nhóm 3 Chia nhỏ sát ngưỡng và tốc độ khởi tạo
                                    </span>
                                </span>
                            </h2>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Chương II Bộ tiêu chí nhận diện • Căn cứ đối chiếu Khoản 3 Điều 29. Các
                                    con số dưới đây là tham số khởi tạo đề xuất, chưa phải mức bắt buộc của
                                    pháp luật. Cảnh báo thủ công vẫn được lập khi có cơ sở nghi ngờ ngoài điều
                                    kiện định lượng.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    TG12 Khoản tiền lặp sát ngưỡng tham chiếu
                                </span>
                            </h3>
                            <p
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textIndent: "22.7pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện phát hiện: ≥ 3 giao dịch trong 7 ngày có giá trị từ 80% đến dưới
                                    100% ngưỡng R phù hợp loại giao dịch; tổng vượt R; hoặc lặp sát hạn mức
                                    sản phẩm L.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xác minh và bằng chứng: R chỉ cấu hình khi xác định đúng phạm vi pháp lý
                                    và sản phẩm cho phép. Nếu R không khả thi, để tiêu chí R không áp dụng và
                                    giám sát sát L riêng; không gọi L là ngưỡng báo cáo.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Ba khoản liên tục sát hạn mức L, chủ ví đổi đối ứng;
                                    xem xét né kiểm soát dựa vào bối cảnh. Mức ưu tiên ban đầu: P3.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    TG13 Khởi tạo nhiều giao dịch quá nhanh
                                </span>
                            </h3>
                            <p
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textIndent: "22.7pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện phát hiện: ≥ 5 yêu cầu chuyển trong 60 giây và trung vị khoảng
                                    cách ≤ 3 giây; tới ≥ 3 chủ ví; tổng yêu cầu ≥ 3 triệu.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xác minh và bằng chứng: Tách yêu cầu, retry và giao dịch hạch toán; loại
                                    retry cùng mã nghiệp vụ. Kiểm tra API được phép, tính tự động hóa và dấu
                                    hiệu chiếm quyền.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Ứng dụng cá nhân phát 8 yêu cầu tới 6 chủ ví trong 25
                                    giây, không có dịch vụ chi trả đã duyệt. Mức ưu tiên ban đầu: P2.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Hồ sơ phải lưu mã giao dịch, phạm vi thời gian, phiên bản tham số và kết
                                    quả đối chiếu bối cảnh. Chỉ đóng khi có chứng cứ phù hợp; nếu chưa đủ dữ
                                    liệu, giữ trạng thái chờ xác minh và theo dõi hạn báo cáo.
                                </span>
                            </p>
                            <h2
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "left",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                                align="left"
                            >
                                <span style={{ fontSize: "13pt" }}>
                                    <a name="_Toc242576923" />
                                    <span style={{ lineHeight: "115%" }}>
                                        Nhóm 4 Khoản nạp lớn bất thường
                                    </span>
                                </span>
                            </h2>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Chương II Bộ tiêu chí nhận diện • Căn cứ đối chiếu Khoản 4 Điều 29. Các
                                    con số dưới đây là tham số khởi tạo đề xuất, chưa phải mức bắt buộc của
                                    pháp luật. Cảnh báo thủ công vẫn được lập khi có cơ sở nghi ngờ ngoài điều
                                    kiện định lượng.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    TG14 Một khoản nạp vượt lịch sử
                                </span>
                            </h3>
                            <p
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textIndent: "22.7pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện phát hiện: Khoản nạp ≥ 20 triệu đồng và ≥ 5 lần trung vị khoản
                                    nạp 30 ngày; nếu chưa đủ 10 khoản lịch sử dùng P99 nhóm tương đồng cùng
                                    ngưỡng tuyệt đối.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xác minh và bằng chứng: Xác minh tài khoản nguồn, nguồn thu, mục đích và
                                    đường đi tiếp. Ngưỡng không cho phép vượt giới hạn pháp luật hoặc hạn mức
                                    sản phẩm.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Ví chỉ nạp 0,5–1 triệu, nay nạp 25 triệu từ tài khoản
                                    liên kết; cần làm rõ dù đúng chủ. Mức ưu tiên ban đầu: P3.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    TG15 Ví mới hoặc ít hoạt động nhận tiền lớn
                                </span>
                            </h3>
                            <p
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textIndent: "22.7pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện phát hiện: Ví mở ≤ 7 ngày hoặc không giao dịch ≥ 90 ngày nhận
                                    nạp ≥ 10 triệu trong 24 giờ; kèm TG02, thiết bị mới hoặc thay đổi thông
                                    tin liên hệ.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xác minh và bằng chứng: Kiểm tra KYC, tái xác thực và sự kiện đổi điện
                                    thoại. Hoạt động trở lại hợp pháp phải được chứng minh trong hồ sơ.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Ví ngừng dùng ba tháng, đổi thiết bị rồi nhận 12
                                    triệu và rút trong 20 phút; chuyển ưu tiên cao. Mức ưu tiên ban đầu: P2.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Hồ sơ phải lưu mã giao dịch, phạm vi thời gian, phiên bản tham số và kết
                                    quả đối chiếu bối cảnh. Chỉ đóng khi có chứng cứ phù hợp; nếu chưa đủ dữ
                                    liệu, giữ trạng thái chờ xác minh và theo dõi hạn báo cáo.
                                </span>
                            </p>
                            <h2
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "left",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                                align="left"
                            >
                                <span style={{ fontSize: "13pt" }}>
                                    <a name="_Toc242576924" />
                                    <span style={{ lineHeight: "115%" }}>
                                        Nhóm 5 Liên hệ thông tin tội phạm công khai
                                    </span>
                                </span>
                            </h2>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Chương II Bộ tiêu chí nhận diện • Căn cứ đối chiếu Khoản 5 Điều 29. Các
                                    con số dưới đây là tham số khởi tạo đề xuất, chưa phải mức bắt buộc của
                                    pháp luật. Cảnh báo thủ công vẫn được lập khi có cơ sở nghi ngờ ngoài điều
                                    kiện định lượng.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    TG16 Trùng khớp thông tin bất lợi có liên quan
                                </span>
                            </h3>
                            <p
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textIndent: "22.7pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện phát hiện: Khách hàng hoặc bên đối ứng có thông tin từ nguồn
                                    đáng tin cậy về tội phạm tạo tài sản bất hợp pháp và có yếu tố định danh
                                    bổ sung khớp. Không đặt ngưỡng tiền.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xác minh và bằng chứng: Kiểm tra họ tên cộng ngày sinh, địa chỉ, mã doanh
                                    nghiệp hoặc dữ kiện khác; lưu đường dẫn, ngày và nội dung liên quan. Đánh
                                    giá nguồn chính thức, bài báo và tình trạng tố tụng.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Tên giống bài báo nhưng khác năm sinh là kết quả có
                                    thể trùng tên; nếu mã doanh nghiệp khớp phải phân tích sâu. Mức ưu tiên
                                    ban đầu: P1 khi có liên hệ đáng tin cậy.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    TG17 Đối ứng với mạng lưới có thông tin bất lợi
                                </span>
                            </h3>
                            <p
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textIndent: "22.7pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện phát hiện: Một giao dịch trực tiếp với bên đã xác minh theo
                                    TG16; hoặc quan hệ gián tiếp có thêm bằng chứng kiểm soát chung hay luân
                                    chuyển nhanh.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xác minh và bằng chứng: Không gán tội cho khách hàng chỉ vì quan hệ gián
                                    tiếp. Xác định giao dịch, thời điểm, vai trò và giới hạn nguồn; xin thông
                                    tin ngân hàng qua kênh hợp pháp.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Ví nhận từ chủ thể có thông tin đáng tin cậy rồi
                                    chuyển qua ba ví mới; ưu tiên phân tích chuỗi. Mức ưu tiên ban đầu: P2
                                    hoặc P1 theo bằng chứng.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Hồ sơ phải lưu mã giao dịch, phạm vi thời gian, phiên bản tham số và kết
                                    quả đối chiếu bối cảnh. Chỉ đóng khi có chứng cứ phù hợp; nếu chưa đủ dữ
                                    liệu, giữ trạng thái chờ xác minh và theo dõi hạn báo cáo.
                                </span>
                            </p>
                            <h2
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "left",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                                align="left"
                            >
                                <span style={{ fontSize: "13pt" }}>
                                    <a name="_Toc242576925" />
                                    <span style={{ lineHeight: "115%" }}>
                                        Nhóm 6 Ví cá nhân giao dịch cho tổ chức hoặc người khác
                                    </span>
                                </span>
                            </h2>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Chương II Bộ tiêu chí nhận diện • Căn cứ đối chiếu Khoản 6 Điều 29. Các
                                    con số dưới đây là tham số khởi tạo đề xuất, chưa phải mức bắt buộc của
                                    pháp luật. Cảnh báo thủ công vẫn được lập khi có cơ sở nghi ngờ ngoài điều
                                    kiện định lượng.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    TG18 Ví cá nhân có mô hình thu tiền kinh doanh
                                </span>
                            </h3>
                            <p
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textIndent: "22.7pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện phát hiện: ≥ 20 người trả trong 7 ngày, tổng nhận ≥ 20 triệu;
                                    kèm nội dung bán hàng hoặc chứng cứ thu cho tổ chức khác với mục đích khai
                                    báo.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xác minh và bằng chứng: Đối chiếu nghề nghiệp, chứng từ đơn hàng, người
                                    hưởng lợi thực tế. Bán hàng hợp pháp cũng phải được xử lý theo điều kiện
                                    sản phẩm; chưa tự động là rửa tiền.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Ví khai dùng cá nhân nhưng nhận tiền cửa hàng do pháp
                                    nhân khác quản lý và định kỳ chuyển toàn bộ. Mức ưu tiên ban đầu: P3.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    TG19 Người khác kiểm soát ví
                                </span>
                            </h3>
                            <p
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textIndent: "22.7pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện phát hiện: Bằng chứng khách hàng giao tài khoản, thiết bị hoặc
                                    thông tin xác thực cho bên khác; hoặc người liên hệ không chứng minh được
                                    quyền đại diện.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xác minh và bằng chứng: Bảo toàn nhật ký, xác minh khách hàng qua kênh đã
                                    đăng ký; phối hợp tuyến gian lận. Ghi nội dung trả lời chính xác, không
                                    chỉ ghi cảm nhận của nhân viên.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Khách hàng xác nhận mở ví theo chỉ dẫn và không biết
                                    người nhận, nguồn tiền; chuyển khẩn nếu đang có giao dịch ra. Mức ưu tiên
                                    ban đầu: P2 hoặc P1.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    TG20 Một người điều hành nhiều ví khác chủ
                                </span>
                            </h3>
                            <p
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textIndent: "22.7pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện phát hiện: ≥ 3 chủ ví có bằng chứng người điều hành chung, cùng
                                    nguồn tiền và cùng người thụ hưởng trong 7 ngày.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xác minh và bằng chứng: Dùng thiết bị hoặc IP làm đầu mối; cần bổ sung
                                    chuỗi giao dịch, KYC, số liên hệ hoặc lời giải thích. Phân biệt người hỗ
                                    trợ kỹ thuật và người quyết định sử dụng tiền.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Ba chủ ví độc lập cùng người liên hệ trả lời mọi câu
                                    hỏi và chuyển tiền đến một bên. Mức ưu tiên ban đầu: P2.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Hồ sơ phải lưu mã giao dịch, phạm vi thời gian, phiên bản tham số và kết
                                    quả đối chiếu bối cảnh. Chỉ đóng khi có chứng cứ phù hợp; nếu chưa đủ dữ
                                    liệu, giữ trạng thái chờ xác minh và theo dõi hạn báo cáo.
                                </span>
                            </p>
                            <h2
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "left",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                                align="left"
                            >
                                <span style={{ fontSize: "13pt" }}>
                                    <a name="_Toc242576926" />
                                    <span style={{ lineHeight: "115%" }}>
                                        Nhóm 7 Đơn vị ngừng hoạt động vẫn giao dịch
                                    </span>
                                </span>
                            </h2>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Chương II Bộ tiêu chí nhận diện • Căn cứ đối chiếu Khoản 7 Điều 29. Các
                                    con số dưới đây là tham số khởi tạo đề xuất, chưa phải mức bắt buộc của
                                    pháp luật. Cảnh báo thủ công vẫn được lập khi có cơ sở nghi ngờ ngoài điều
                                    kiện định lượng.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    TG21 Giao dịch sau khi xác minh ngừng hoạt động
                                </span>
                            </h3>
                            <p
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textIndent: "22.7pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện phát hiện: Có giao dịch mới sau thời điểm xác minh website chính
                                    thức hoặc trụ sở ngừng hoạt động. Không đặt ngưỡng tiền.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xác minh và bằng chứng: Lưu bằng chứng xác minh và thời điểm; phân biệt
                                    lỗi website ngắn hạn, đổi tên miền, chuyển địa điểm với ngừng hoạt động.
                                    Đối chiếu đơn hàng phát sinh trước khi ngừng và kỳ đối soát.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Trụ sở đóng và người đại diện xác nhận dừng kinh
                                    doanh, nhưng đơn hàng mới vẫn phát sinh. Mức ưu tiên ban đầu: P2.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    TG22 Thanh toán hoặc hoàn tiền thiếu giao dịch kinh tế
                                </span>
                            </h3>
                            <p
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textIndent: "22.7pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện phát hiện: ĐVCNTT đã ngừng hoạt động phát sinh ≥ 5 giao dịch mới
                                    trong 24 giờ, tổng ≥ 5 triệu; hoặc hoàn tiền không liên kết được đơn hàng
                                    gốc.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xác minh và bằng chứng: Đối soát đơn gốc, thời điểm bán, giao hàng, người
                                    hoàn và bên nhận. Khoản thanh toán chậm cho đơn cũ cần kiểm tra chứng từ
                                    trước khi đóng cảnh báo.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Hoàn tiền tới ví không phải người mua ban đầu sau khi
                                    website dừng; phân tích liên hệ chủ thể và tiền. Mức ưu tiên ban đầu: P2.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Hồ sơ phải lưu mã giao dịch, phạm vi thời gian, phiên bản tham số và kết
                                    quả đối chiếu bối cảnh. Chỉ đóng khi có chứng cứ phù hợp; nếu chưa đủ dữ
                                    liệu, giữ trạng thái chờ xác minh và theo dõi hạn báo cáo.
                                </span>
                            </p>
                            <h2
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "left",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                                align="left"
                            >
                                <span style={{ fontSize: "13pt" }}>
                                    <a name="_Toc242576927" />
                                    <span style={{ lineHeight: "115%" }}>
                                        Nhóm 8 Thay đổi liên tục thiết bị và IP
                                    </span>
                                </span>
                            </h2>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Chương II Bộ tiêu chí nhận diện • Căn cứ đối chiếu Khoản 8 Điều 29. Các
                                    con số dưới đây là tham số khởi tạo đề xuất, chưa phải mức bắt buộc của
                                    pháp luật. Cảnh báo thủ công vẫn được lập khi có cơ sở nghi ngờ ngoài điều
                                    kiện định lượng.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    TG23 Nhiều thiết bị trong thời gian ngắn
                                </span>
                            </h3>
                            <p
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textIndent: "22.7pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện phát hiện: ≥ 3 thiết bị phân biệt trong 24 giờ và có ≥ 3 yêu cầu
                                    giao dịch; tăng ưu tiên khi ≥ 5 thiết bị trong 7 ngày kèm TG02.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xác minh và bằng chứng: Dùng mã thiết bị ổn định; loại thay đổi giả do cập
                                    nhật ứng dụng hoặc đặt lại định danh. Kiểm tra thay điện thoại, hỗ trợ gia
                                    đình, thiết bị doanh nghiệp và hành vi ra tiền.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Ví thực hiện rút từ bốn thiết bị mới trong một ngày
                                    và đổi mật khẩu; phối hợp tuyến gian lận. Mức ưu tiên ban đầu: P3 hoặc P2.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    TG24 IP đổi liên tục và vị trí không phù hợp
                                </span>
                            </h3>
                            <p
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textIndent: "22.7pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện phát hiện: ≥ 5 IP công cộng trong 2 giờ có giao dịch và ≥ 2 vùng
                                    địa lý theo nguồn định vị; hoặc dấu hiệu chuyển quốc gia trong thời gian
                                    bất khả thi kèm thiết bị mới.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xác minh và bằng chứng: Kiểm tra mạng di động, NAT, VPN, proxy, sai số
                                    định vị và thời gian máy chủ. Không đồng nhất vị trí IP với vị trí vật lý
                                    đã xác minh.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Đăng nhập qua nhiều dải IP kèm chuyển nhanh, nhưng
                                    nhà mạng đổi IP hợp pháp phải được loại trừ có chứng cứ. Mức ưu tiên ban
                                    đầu: P3 hoặc P2.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Hồ sơ phải lưu mã giao dịch, phạm vi thời gian, phiên bản tham số và kết
                                    quả đối chiếu bối cảnh. Chỉ đóng khi có chứng cứ phù hợp; nếu chưa đủ dữ
                                    liệu, giữ trạng thái chờ xác minh và theo dõi hạn báo cáo.
                                </span>
                            </p>
                            <h2
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "left",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                                align="left"
                            >
                                <span style={{ fontSize: "13pt" }}>
                                    <a name="_Toc242576928" />
                                    <span style={{ lineHeight: "115%" }}>
                                        Nhóm 9 Truy cập nước ngoài và dùng chung nhiều ví
                                    </span>
                                </span>
                            </h2>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Chương II Bộ tiêu chí nhận diện • Căn cứ đối chiếu Khoản 9 Điều 29. Các
                                    con số dưới đây là tham số khởi tạo đề xuất, chưa phải mức bắt buộc của
                                    pháp luật. Cảnh báo thủ công vẫn được lập khi có cơ sở nghi ngờ ngoài điều
                                    kiện định lượng.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    TG25 Thường xuyên truy cập từ IP nước ngoài
                                </span>
                            </h3>
                            <p
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textIndent: "22.7pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện phát hiện: ≥ 3 ngày trong 7 ngày có đăng nhập thành công hoặc
                                    giao dịch từ IP định vị ngoài Việt Nam; thêm yếu tố nguồn tiền bất thường
                                    hoặc khác hồ sơ thì nâng P2.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xác minh và bằng chứng: Đối chiếu cư trú, công tác, du lịch, roaming, VPN
                                    và độ tin cậy định vị. Quốc gia rủi ro được theo dõi theo danh mục riêng
                                    có phê duyệt.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Khách đi công tác có bằng chứng và hoạt động phù hợp
                                    có thể đóng; truy cập ngoài nước kèm nhiều ví cần mở rộng. Mức ưu tiên ban
                                    đầu: P3.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    TG26 Một thiết bị giao dịch trên nhiều ví khác chủ
                                </span>
                            </h3>
                            <p
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textIndent: "22.7pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện phát hiện: Một mã thiết bị dùng cho ≥ 3 chủ ví trong 24 giờ và
                                    có giao dịch; hoặc ≥ 5 chủ trong 7 ngày.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xác minh và bằng chứng: Kiểm tra thiết bị dùng chung gia đình, kiosk được
                                    phép, định danh thiết bị trùng giả; đánh giá nguồn tiền và người thụ hưởng
                                    chung.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: Một điện thoại thao tác năm ví khác chủ, mỗi ví gom
                                    tiền rồi chuyển cùng đích; mở hồ sơ mạng lưới. Mức ưu tiên ban đầu: P2.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    TG27 Một IP giao dịch trên nhiều ví khác chủ
                                </span>
                            </h3>
                            <p
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textIndent: "22.7pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Điều kiện phát hiện: Một IP dùng bởi ≥ 10 chủ ví trong 60 phút có giao
                                    dịch; kèm chuỗi tiền tương tự, thiết bị liên quan hoặc cùng người nhận.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Xác minh và bằng chứng: IP chung không đủ để kết luận do NAT và mạng công
                                    ty. Nếu không có yếu tố bổ sung, chuyển thành tín hiệu theo dõi kỹ thuật
                                    và rà soát mẫu.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Tình huống giả định: IP văn phòng có nhiều ví thanh toán độc lập khác với
                                    nhóm ví chuyển tiền đồng loạt đến một đích. Mức ưu tiên ban đầu: P3 hoặc
                                    P2.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Hồ sơ phải lưu mã giao dịch, phạm vi thời gian, phiên bản tham số và kết
                                    quả đối chiếu bối cảnh. Chỉ đóng khi có chứng cứ phù hợp; nếu chưa đủ dữ
                                    liệu, giữ trạng thái chờ xác minh và theo dõi hạn báo cáo.
                                </span>
                            </p>
                            <h2
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "center",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                                align="center"
                            >
                                <span style={{ fontSize: "13pt" }}>
                                    <a name="_Toc242576929" />
                                    <span style={{ lineHeight: "115%" }}>
                                        MỤC 3<br />
                                        TIÊU CHÍ NỘI BỘ KHÁC VÀ QUẢN LÝ NGOẠI LỆ
                                    </span>
                                </span>
                            </h2>
                            <h2
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ fontSize: "13pt" }}>
                                    <a name="_Toc242576930" />
                                    <span style={{ lineHeight: "115%" }}>
                                        Điều 12. Tiêu chí Công ty tự xác định
                                    </span>
                                </span>
                            </h2>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    TG28–TG30 là các cơ chế nội bộ khác hoặc bổ trợ cho CB01–CB12 và
                                    TG01–TG27. Đây không phải các khoản mới của Điều 27 hoặc Điều 29. Công ty
                                    áp dụng trên cơ sở rủi ro và kiểm định; một sự kiện được quản lý trong một
                                    hồ sơ với đầy đủ mã liên quan.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    TG28 Cảnh báo bổ trợ về thông tin khách hàng
                                </span>
                            </h3>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Phát hiện tài liệu không xác minh được, nguồn tiền khác lời khai, bên
                                    hưởng lợi không rõ hoặc từ chối cung cấp thông tin cần thiết sau yêu cầu
                                    phù hợp. Không đặt ngưỡng tiền; chuyển PCRT đánh giá toàn bộ hồ sơ, tránh
                                    đồng nhất việc chậm trả lời với hành vi phạm tội. Khi liên quan đến từ
                                    chối hoặc thông tin KYC sai, thiếu, mâu thuẫn thì ghi thêm CB01 hoặc CB02;
                                    khi không xác định được danh tính thì ghi CB04 hoặc CB05. TG28 không thay
                                    thế việc đối chiếu Điều 27 và không được dùng để bỏ qua mã CB tương ứng.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    TG29 Thanh toán và hoàn tiền phối hợp
                                </span>
                            </h3>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Đề xuất cảnh báo khi ≥ 5 hoàn tiền trong 7 ngày, tỷ lệ hoàn ≥ 50% số thanh
                                    toán thành công của cùng tập đơn, kèm bên nhận khác người trả hoặc mối
                                    liên hệ thiết bị. Kiểm tra đổi trả hợp pháp, trạng thái đơn và đối soát
                                    trước khi nâng ưu tiên P2.
                                </span>
                            </p>
                            <h3
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    TG30 Dấu hiệu ngoài hệ thống tự động
                                </span>
                            </h3>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Nhân viên, ngân hàng đối tác, phản ánh khách hàng hoặc cơ quan có thẩm
                                    quyền cung cấp thông tin có căn cứ về giao dịch hoặc chủ thể. Nhân viên
                                    lập hồ sơ ngay, mô tả nguồn, nội dung, ngày nhận và độ tin cậy; không phải
                                    chờ vượt ngưỡng kỹ thuật.
                                </span>
                            </p>
                            <h2
                                style={{
                                    margin: "10pt 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    breakAfter: "avoid",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ fontSize: "13pt" }}>
                                    <a name="_Toc242576931" />
                                    <span style={{ lineHeight: "115%" }}>Điều 13. Quản lý ngoại lệ</span>
                                </span>
                            </h2>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Ngoại lệ chỉ giảm cảnh báo lặp do hoạt động đã xác minh; phải có tiêu chí
                                    áp dụng, chủ thể, chứng cứ, người phê duyệt, ngày hết hạn và lịch rà soát.
                                    Đề xuất thời hạn tối đa 30 ngày cho lần phê duyệt đầu; gia hạn cần kiểm
                                    tra giao dịch mới.
                                </span>
                            </p>
                            <p
                                style={{
                                    textIndent: "22.7pt",
                                    margin: "0cm 0cm 6pt",
                                    textAlign: "justify",
                                    lineHeight: "115%",
                                    fontSize: "12pt",
                                    fontFamily: '"Times New Roman", serif',
                                    color: "black"
                                }}
                            >
                                <span style={{ lineHeight: "115%", fontSize: "13pt" }}>
                                    Không miễn rà soát đối với thông tin bất lợi mới, danh sách chính thức,
                                    thay đổi người kiểm soát, giao dịch khác phạm vi ngoại lệ hoặc nghĩa vụ
                                    báo cáo. Hệ thống lưu số cảnh báo bị giảm và kiểm tra mẫu. Ngoại lệ tự hết
                                    hiệu lực khi chứng cứ nền thay đổi. Ngoại lệ TG không miễn kiểm tra CB;
                                    các yêu cầu không báo cáo, không xác minh được danh tính, thông tin danh
                                    sách mới hoặc yêu cầu trái pháp luật phải chuyển tuyến riêng.
                                </span>
                            </p>
                        </>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SuspiciousCriteria;
